/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DesignInstallationOverview } from "./DesignInstallationOverview";
import {
  DesignInstallationOverviewFromJSON,
  DesignInstallationOverviewFromJSONTyped,
  DesignInstallationOverviewToJSON,
  DesignInstallationOverviewToJSONTyped,
} from "./DesignInstallationOverview";

/**
 *
 * @export
 * @interface GUFDetail
 */
export interface GUFDetail {
  /**
   *
   * @type {string}
   * @memberof GUFDetail
   */
  readonly uuid?: string;
  /**
   *
   * @type {Array<DesignInstallationOverview>}
   * @memberof GUFDetail
   */
  readonly installations?: Array<DesignInstallationOverview>;
  /**
   *
   * @type {string}
   * @memberof GUFDetail
   */
  readonly nrOfInstallations?: string;
  /**
   *
   * @type {string}
   * @memberof GUFDetail
   */
  readonly nrOfEvents?: string;
  /**
   *
   * @type {Date}
   * @memberof GUFDetail
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GUFDetail
   */
  readonly updated?: Date;
  /**
   * Alleen beschikbaar voor de eigenaar van de put.
   * @type {string}
   * @memberof GUFDetail
   */
  internalId: string | null;
  /**
   *
   * @type {string}
   * @memberof GUFDetail
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GUFDetail
   */
  deliveryAccountableParty: string | null;
  /**
   *
   * @type {GUFDetailQualityRegimeEnum}
   * @memberof GUFDetail
   */
  qualityRegime: GUFDetailQualityRegimeEnum | null;
  /**
   *
   * @type {GUFDetailDeliveryContextEnum}
   * @memberof GUFDetail
   */
  deliveryContext: GUFDetailDeliveryContextEnum | null;
  /**
   * Format: YYYY-MM-DD, YYYY-MM, or YYYY
   * @type {Date}
   * @memberof GUFDetail
   */
  startTime: Date | null;
  /**
   * Format: YYYY-MM-DD, YYYY-MM, or YYYY
   * @type {Date}
   * @memberof GUFDetail
   */
  endTime: Date | null;
  /**
   *
   * @type {string}
   * @memberof GUFDetail
   */
  identificationLicence: string | null;
  /**
   *
   * @type {GUFDetailLegalTypeEnum}
   * @memberof GUFDetail
   */
  legalType: GUFDetailLegalTypeEnum | null;
  /**
   *
   * @type {GUFDetailPrimaryUsageTypeEnum}
   * @memberof GUFDetail
   */
  primaryUsageType: GUFDetailPrimaryUsageTypeEnum | null;
  /**
   *
   * @type {object}
   * @memberof GUFDetail
   */
  secondaryUsageTypes: object;
  /**
   *
   * @type {GUFDetailHumanConsumptionEnum}
   * @memberof GUFDetail
   */
  humanConsumption: GUFDetailHumanConsumptionEnum | null;
  /**
   *
   * @type {object}
   * @memberof GUFDetail
   */
  licensedQuantities: object;
  /**
   *
   * @type {string}
   * @memberof GUFDetail
   */
  dataOwner: string;
}

/**
 * @export
 */
export const GUFDetailQualityRegimeEnum = {
  Imbro: "IMBRO",
  ImbroA: "IMBRO/A",
} as const;
export type GUFDetailQualityRegimeEnum =
  (typeof GUFDetailQualityRegimeEnum)[keyof typeof GUFDetailQualityRegimeEnum];

/**
 * @export
 */
export const GUFDetailDeliveryContextEnum = {
  Waterwet: "waterwet",
  Omgevingswet: "omgevingswet",
} as const;
export type GUFDetailDeliveryContextEnum =
  (typeof GUFDetailDeliveryContextEnum)[keyof typeof GUFDetailDeliveryContextEnum];

/**
 * @export
 */
export const GUFDetailLegalTypeEnum = {
  Melding: "melding",
  Beschikking: "beschikking",
} as const;
export type GUFDetailLegalTypeEnum =
  (typeof GUFDetailLegalTypeEnum)[keyof typeof GUFDetailLegalTypeEnum];

/**
 * @export
 */
export const GUFDetailPrimaryUsageTypeEnum = {
  AgrarischeDoeleinden: "agrarischeDoeleinden",
  Bemaling: "bemaling",
  Brandblusvoorziening: "brandblusvoorziening",
  GeslotenBodemenergiesysteem: "geslotenBodemenergiesysteem",
  Grondwatersanering: "grondwatersanering",
  IndustrieleToepassing: "industrieleToepassing",
  OpenBodemenergiesysteem: "openBodemenergiesysteem",
  OpenbareDrinkwatervoorziening: "openbareDrinkwatervoorziening",
  OverigeDoeleinden: "overigeDoeleinden",
} as const;
export type GUFDetailPrimaryUsageTypeEnum =
  (typeof GUFDetailPrimaryUsageTypeEnum)[keyof typeof GUFDetailPrimaryUsageTypeEnum];

/**
 * @export
 */
export const GUFDetailHumanConsumptionEnum = {
  Ja: "ja",
  Nee: "nee",
  Onbekend: "onbekend",
} as const;
export type GUFDetailHumanConsumptionEnum =
  (typeof GUFDetailHumanConsumptionEnum)[keyof typeof GUFDetailHumanConsumptionEnum];

/**
 * Check if a given object implements the GUFDetail interface.
 */
export function instanceOfGUFDetail(value: object): value is GUFDetail {
  if (
    (!("internalId" in (value as Record<string, any>)) &&
      !("internal_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["internalId"] === undefined &&
      (value as Record<string, any>)["internal_id"] === undefined)
  )
    return false;
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("deliveryAccountableParty" in (value as Record<string, any>)) &&
      !("delivery_accountable_party" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryAccountableParty"] === undefined &&
      (value as Record<string, any>)["delivery_accountable_party"] === undefined)
  )
    return false;
  if (
    (!("qualityRegime" in (value as Record<string, any>)) &&
      !("quality_regime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["qualityRegime"] === undefined &&
      (value as Record<string, any>)["quality_regime"] === undefined)
  )
    return false;
  if (
    (!("deliveryContext" in (value as Record<string, any>)) &&
      !("delivery_context" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryContext"] === undefined &&
      (value as Record<string, any>)["delivery_context"] === undefined)
  )
    return false;
  if (
    (!("startTime" in (value as Record<string, any>)) &&
      !("start_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startTime"] === undefined &&
      (value as Record<string, any>)["start_time"] === undefined)
  )
    return false;
  if (
    (!("endTime" in (value as Record<string, any>)) &&
      !("end_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endTime"] === undefined &&
      (value as Record<string, any>)["end_time"] === undefined)
  )
    return false;
  if (
    (!("identificationLicence" in (value as Record<string, any>)) &&
      !("identification_licence" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["identificationLicence"] === undefined &&
      (value as Record<string, any>)["identification_licence"] === undefined)
  )
    return false;
  if (
    (!("legalType" in (value as Record<string, any>)) &&
      !("legal_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["legalType"] === undefined &&
      (value as Record<string, any>)["legal_type"] === undefined)
  )
    return false;
  if (
    (!("primaryUsageType" in (value as Record<string, any>)) &&
      !("primary_usage_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["primaryUsageType"] === undefined &&
      (value as Record<string, any>)["primary_usage_type"] === undefined)
  )
    return false;
  if (
    (!("secondaryUsageTypes" in (value as Record<string, any>)) &&
      !("secondary_usage_types" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["secondaryUsageTypes"] === undefined &&
      (value as Record<string, any>)["secondary_usage_types"] === undefined)
  )
    return false;
  if (
    (!("humanConsumption" in (value as Record<string, any>)) &&
      !("human_consumption" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["humanConsumption"] === undefined &&
      (value as Record<string, any>)["human_consumption"] === undefined)
  )
    return false;
  if (
    (!("licensedQuantities" in (value as Record<string, any>)) &&
      !("licensed_quantities" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["licensedQuantities"] === undefined &&
      (value as Record<string, any>)["licensed_quantities"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GUFDetailFromJSON(json: any): GUFDetail {
  return GUFDetailFromJSONTyped(json, false);
}

export function GUFDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): GUFDetail {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    installations:
      json["installations"] == null
        ? undefined
        : (json["installations"] as Array<any>).map(DesignInstallationOverviewFromJSON),
    nrOfInstallations:
      json["nr_of_installations"] == null ? undefined : json["nr_of_installations"],
    nrOfEvents: json["nr_of_events"] == null ? undefined : json["nr_of_events"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    internalId: json["internal_id"],
    broId: json["bro_id"],
    deliveryAccountableParty: json["delivery_accountable_party"],
    qualityRegime: json["quality_regime"],
    deliveryContext: json["delivery_context"],
    startTime: json["start_time"] == null ? null : new Date(json["start_time"]),
    endTime: json["end_time"] == null ? null : new Date(json["end_time"]),
    identificationLicence: json["identification_licence"],
    legalType: json["legal_type"],
    primaryUsageType: json["primary_usage_type"],
    secondaryUsageTypes: json["secondary_usage_types"],
    humanConsumption: json["human_consumption"],
    licensedQuantities: json["licensed_quantities"],
    dataOwner: json["data_owner"],
  };
}

export function GUFDetailToJSON(json: any): GUFDetail {
  return GUFDetailToJSONTyped(json, false);
}

export function GUFDetailToJSONTyped(
  value?: Omit<
    GUFDetail,
    "uuid" | "installations" | "nr_of_installations" | "nr_of_events" | "created" | "updated"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    internal_id: value["internalId"],
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    quality_regime: value["qualityRegime"],
    delivery_context: value["deliveryContext"],
    start_time:
      value["startTime"] == null
        ? value["startTime"]
        : value["startTime"].toISOString().substring(0, 10),
    end_time:
      value["endTime"] == null ? value["endTime"] : value["endTime"].toISOString().substring(0, 10),
    identification_licence: value["identificationLicence"],
    legal_type: value["legalType"],
    primary_usage_type: value["primaryUsageType"],
    secondary_usage_types: value["secondaryUsageTypes"],
    human_consumption: value["humanConsumption"],
    licensed_quantities: value["licensedQuantities"],
    data_owner: value["dataOwner"],
  };
}
